export default "__VITE_ASSET__8jkeyLMn__"